var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"circle",class:_vm.circle.class,attrs:{"version":"1.1","baseProfile":"tiny","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 200 200","xml:space":"preserve"}},[_c('g',[_c('circle',{attrs:{"x":"100","y":"100","r":"100"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }